import React, {lazy, useEffect, useState} from 'react'
import './App.css';
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom'
import {themeChange} from 'theme-change'
import checkAuth from './app/auth';
import initializeApp from './app/init';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Importing pages
const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const Register = lazy(() => import('./pages/Register'))
const Documentation = lazy(() => import('./pages/Documentation'))


// Initializing different libraries
initializeApp()

function App() {
    const [tokenValid, setTokenValid] = useState(null);
    useEffect(() => {
        const verifyToken = async () => {
            const isValid = await checkAuth();
            setTokenValid(isValid);
        };
        verifyToken();


        // 👆 daisy UI themes initialization
        themeChange(false)
    }, [])

    if (tokenValid === null) {
        // Hiển thị loading hoặc skeleton khi đang kiểm tra token
        document.body.classList.add('loading-indicator');
        return <div></div>;
    }

    document.body.classList.remove('loading-indicator');

    return (
        <>
            <Router>
                <Routes>
                    <Route path="/login" element={tokenValid ? <Navigate to="/dashboard" replace/> : <Login/>}/>
                    <Route path="/forgot-password"
                           element={tokenValid ? <Navigate to="/dashboard" replace/> : <ForgotPassword/>}/>
                    <Route path="/register" element={tokenValid ? <Navigate to="/dashboard" replace/> : <Register/>}/>

                    {/* Place new routes over this */}
                    <Route path="/app/*" element={tokenValid ? <Layout/> : <Navigate to="/login" replace/>}/>

                    <Route path="*" element={<Navigate to={tokenValid ? "/app/welcome" : "/login"} replace/>}/>

                </Routes>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Router>
        </>
    )
}

export default App
